import React from 'react';
import classNames from 'classnames';

import { i18n } from 'app/i18n';
import { Typography } from 'app/components/domain/typography';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { OrderUtils } from 'app/page/orders/utils/order-utils';
import { Card } from 'app/components/domain/card/card';
import { NavigationService, navigationService } from 'app/service/navigation-service';
import { DateUtils } from 'app/utils/date-utils';
import { Image } from 'app/components/common/image';
import { Button } from 'app/components/common/buttons';
import edit from 'app/resources/edit.svg';

import styles from './connection-and-activation.module.scss';

interface Props {
    activeOrder: ActiveOrder;
}

export const ConnectionAndActivation: React.FC<Props> = (props) => {
    const { activeOrder } = props;
    const orderAppointment = OrderUtils.findAppointment(activeOrder);
    const hasAppointment = !!orderAppointment;
    const showDate = hasAppointment ? !!orderAppointment.date : true;

    const handleClickEditConnectionAndActivationDate = () => {
        navigationService.goToPath(NavigationService.RESCHEDULE_TECHNICIAN);
    };

    const handleClickEditActivationDate = () => {
        navigationService.goToPath(NavigationService.UPDATE_ACTIVATION_DATE);
    };

    const renderAppointmentDate = (appointment: OrderTrackerBackend.Appointment) => {
        const { date, timeSlot } = appointment;

        if (!date) {
            return null;
        }

        return (
            <>
                <Typography variant="body2" component="span">
                    {DateUtils.getDateWithDayOfWeek(date)}
                </Typography>
                {timeSlot && (
                    <Typography variant="body2" component="span" className={styles.time}>
                        {i18n.rescheduleTechnician.form.timeSlot[timeSlot]}
                    </Typography>
                )}
            </>
        );
    };

    return (
        <Card>
            <div className={classNames(styles.container, !showDate && styles.containerWithoutDate)}>
                <Typography variant="subtitle3" component="p" className={styles.title}>
                    {i18n.summary.connectionAndActivationDate.title}
                </Typography>
                {(hasAppointment || OrderUtils.canChangeActivationDate(activeOrder)) && (
                    <Button
                        className={styles.button}
                        submitting={false}
                        onClick={
                            hasAppointment ? handleClickEditConnectionAndActivationDate : handleClickEditActivationDate
                        }
                        type="link"
                    >
                        <Image src={edit} alt={i18n.image.edit} className={styles.image} />
                        <Typography variant="body2" component="span">
                            {i18n.summary.connectionAndActivationDate.changeLink}
                        </Typography>
                    </Button>
                )}
                {showDate && (
                    <div className={styles.dateContainer}>
                        {hasAppointment ? (
                            renderAppointmentDate(orderAppointment)
                        ) : (
                            <Typography variant="body2" component="span">
                                {DateUtils.getDateWithDayOfWeek(OrderUtils.getActivationDate(activeOrder))}
                            </Typography>
                        )}
                    </div>
                )}
            </div>
        </Card>
    );
};
